module.exports = __webpack_public_path__ + "static/media/ofir shaty.1f06c8ee.png";